import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  header?: ReactNode;
  footer?: ReactNode;
}

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ header, footer, className = '', children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={[
          'bg-bg-card rounded-md shadow-card',
          'border border-border',
          'bg-gradient-to-br from-bg-card to-bg-surface',
          'transition-all duration-default ease-spring',
          'hover:shadow-hover hover:border-secondary/30 hover:-translate-y-1',
          'motion-reduce:hover:translate-y-0 motion-reduce:transition-shadow',
          'animate-pop-in',
          className,
        ].join(' ')}
        {...props}
      >
        {header && (
          <div className="px-5 py-4 border-b border-border">
            {header}
          </div>
        )}
        <div className="px-5 py-4">{children}</div>
        {footer && (
          <div className="px-5 py-4 border-t border-border">
            {footer}
          </div>
        )}
      </div>
    );
  }
);

Card.displayName = 'Card';
